import { Component, EventEmitter, Input, Output } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [RouterLink, RouterLinkActive, NgbTooltipModule, TranslocoDirective],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss'
})
export class SidebarComponent {
  @Input() isCollapseSidebar: boolean = false;
  @Input() isCompact: boolean = false;
  @Input() closeSidebar?: () => void;
  // readonly toggleCollapse = output<void>();
  @Output() toggleCollapse = new EventEmitter<void>();

  btnCollapsProps(): void {
    this.toggleCollapse.emit();
  }
}